export const namedRoutes: {[key: string]: {title:string, info: string}} = {
    '/CollectionsPage' : { 
        title:'Коллекция',
        info:'Уникальные наборы гачи, которые можно добавлять к себе в коллекцию!',
    },
    '/MapPage': { 
        title:'Карта',
        info:'Ищи наши автоматы по всей Москве, а также посещай Gacha Bunker.',
    },
    '/LeadersPage': { 
        title:'Рейтинг',
        info:'Рейтинг коллекционеров,которых мы ежемесячно награждаем за сбор уникальных коллекций от Lootball. Сканируй наши QR-коды и участвуй в нашем еемесячном турнире!',
    },
    '/MissionsPage': { 
        title:'Задания',
        info:'Коротенькие задания, чтобы влиться в наше комьюнити! А также чтобы не пропустить наши новинки и эксклюзивы.',
    },
    '/BonusPage': { 
        title:'Баланс',
        info:'Получай бонусы за задания, участие в турнире коллекционеров, сбор ачивок и приглашение друзей!',
    },
    '/TransactionsPage': { 
        title:'Транзакции',
        info:'Здесь отображаются операции по вашему бонусному счету.'
    },
    '/AchievementsPage': { 
        title:'Достижения',
        info:'Собирай уникальные ачивки, выполняя задания от Lootball! Какие-то задания выполнить довольно просто, но некоторые потребуют взаимодействия с сообществом. Дерзай!'
    }
};
